// extracted by mini-css-extract-plugin
export default {"wrapper":"MainPage_wrapper__k0tL8","contentWrapper":"MainPage_contentWrapper__-oQdF","content":"MainPage_content__PIKeZ","menuWrapper":"MainPage_menuWrapper__k6--f"};